// removed by extract-text-webpack-plugin
module.exports = {"button":"_2fqTH4X5F1xqz2TkbwFLco","open":"NJ0U8juv5etFKBmgnZHhi","arrow":"_1ypOI9mdl1F1FV10_66k3P","filters":"_1Tuii-ZWJqpJyzowftEnH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterToggleButton/FilterToggleButton.module.scss
// module id = 764
// module chunks = 0